import { GlIcon, GlLink, GlKeysetPagination, GlTable, GlTooltipDirective, GlLoadingIcon } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { MountingPortal } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/portal_vue_vue3.js?vue3';
import { fetchPolicies } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/graphql.js?vue3';
import * as Sentry from '~/sentry/sentry_browser_wrapper';
import { __, s__ } from '~/locale';
import DynamicPanel from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/dynamic_panel.vue?vue3';
import UserDate from '~/vue_shared/components/user_date.vue';
import ErrorsAlert from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/errors_alert.vue?vue3';
import { PAGE_SIZE } from '../constants';
import serviceAccountProjectMembershipsQuery from '../graphql/queries/service_account_project_memberships.query.graphql';
import ServiceAccountAvatar from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/ai/catalog/components/service_account_avatar.vue?vue3';
export default {
    name: 'ServiceAccountProjectMemberships',
    components: {
        GlIcon,
        GlLink,
        GlKeysetPagination,
        GlTable,
        GlLoadingIcon,
        DynamicPanel,
        ErrorsAlert,
        MountingPortal,
        ServiceAccountAvatar,
        UserDate
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        serviceAccount: {
            type: Object,
            required: true
        },
        isOpen: {
            type: Boolean,
            required: true
        }
    },
    emits: [
        'close'
    ],
    apollo: {
        projectMemberships: {
            query: serviceAccountProjectMembershipsQuery,
            skip () {
                return !this.isOpen;
            },
            variables () {
                return {
                    userId: this.serviceAccount.id,
                    first: PAGE_SIZE,
                    after: null,
                    before: null,
                    last: null
                };
            },
            fetchPolicy: fetchPolicies.CACHE_AND_NETWORK,
            update: (data)=>data?.user?.projectMemberships?.nodes ?? [],
            result ({ data }) {
                this.pageInfo = data?.user?.projectMemberships?.pageInfo;
            },
            error (error) {
                this.handleError(error);
            }
        }
    },
    data () {
        return {
            projectMemberships: [],
            errors: [],
            pageInfo: null
        };
    },
    computed: {
        isLoading () {
            return this.$apollo.queries.projectMemberships.loading;
        }
    },
    methods: {
        handleClose () {
            this.$emit('close');
        },
        handleError (error) {
            this.errors = [
                this.$options.errorMessage
            ];
            Sentry.captureException(error);
        },
        handleNextPage () {
            this.$apollo.queries.projectMemberships.refetch({
                ...this.$apollo.queries.projectMemberships.variables,
                before: null,
                after: this.pageInfo.endCursor,
                first: PAGE_SIZE,
                last: null
            }).catch((error)=>{
                this.handleError(error);
            });
        },
        handlePrevPage () {
            this.$apollo.queries.projectMemberships.refetch({
                ...this.$apollo.queries.projectMemberships.variables,
                after: null,
                before: this.pageInfo.startCursor,
                first: null,
                last: PAGE_SIZE
            }).catch((error)=>{
                this.handleError(error);
            });
        }
    },
    fields: [
        {
            key: 'project',
            label: __('Name'),
            isRowHeader: true
        },
        {
            key: 'accessLevel.humanAccess',
            label: s__('AICatalog|Access level'),
            isRowHeader: true,
            class: 'gl-whitespace-nowrap'
        },
        {
            key: 'createdAt',
            label: __('Activity'),
            isRowHeader: true,
            thAlignRight: true
        }
    ],
    errorMessage: s__('AICatalog|Failed to load project memberships. Please try again.')
};
